import React, { useContext, useEffect, useState } from 'react';
import { GlobalStateContext } from './GlobalStateContext.js';

const ResultTable = ({ data }) => {
    const { answerSet, setAnswerSet } = useContext(GlobalStateContext);

    const [showPopup, setShowPopup] = useState(null);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [originalAnswers, setOriginalAnswers] = useState({});

    useEffect(() => {
        if (data) {
            updateOriginalAnswers();
        }
    }, [data]);

    const updateOriginalAnswers = () => {
        const originalAnswers = {};
        data.forEach(row => {
            originalAnswers[row.question_id] = row.answerValue;
        });
        setOriginalAnswers(originalAnswers);
    };

    const togglePopup = (question_id) => {
        setShowPopup(prevShowPopup => prevShowPopup === question_id ? null : question_id);
    };

    const changeAnswer = (question_id, newAnswerIndex) => {
        //console.log("Hier wurde die Antwort für Frage", question_id, "geändert:", newAnswerIndex);
        setSelectedAnswers(prevSelectedAnswers => ({
            ...prevSelectedAnswers,
            [question_id]: newAnswerIndex,
        }));

        const updatedArray = answerSet.map(item => {
            if (item.question_id === question_id) {
                return { ...item, answerValue: newAnswerIndex.toString() };
            }
            return item;
        });
        setAnswerSet(updatedArray);
    };

    const resetAnswer = (question_id) => {
        setSelectedAnswers(prevSelectedAnswers => ({
            ...prevSelectedAnswers,
            [question_id]: originalAnswers[question_id],
        }));
        togglePopup(question_id);
    };

    const valueToAnswer = {};

    if (!data) {
        return null; // Keine Daten vorhanden, also nichts rendern
    }

    return (
        <table className='resultTable'>
            <thead className='resultHead'>
                <tr className='resultRow'>
                    <th className='resultHeadNo'>Nr.</th>
                    <th className='resultHeadQuestion'>Frage</th>
                    <th className='resultHeadAnswer'>Antwort</th>
                    <th className='resultHeadAction'>Aktion</th>
                </tr>
            </thead>
            <tbody>
                {data.map((row, index) => {
                    const question_id = row.question_id;
                    const questionType = row.Question_Type;
                    //console.log("rowAn", row.answerValue);
                    let answer = '';

                    if (questionType === 'offen') {
                        answer = row.answerValue;
                    } else {
                        const answerArray = (row.answerText || '').split(';'); // Default to empty string if answerText is null
                        const answerIds = (row.answerPossibilities || '').split(';'); // Default to empty string if answerPossibilities is null

                        if (!valueToAnswer[question_id]) {
                            valueToAnswer[question_id] = {};
                        }

                        answerIds.forEach((answerId, index) => {
                            valueToAnswer[question_id][answerId] = answerArray[index];
                        });

                        answer = valueToAnswer[question_id][row.answerValue];
                    }

                    const selectedAnswer = selectedAnswers[question_id];
                    const popupanswerValue = selectedAnswer ? parseInt(selectedAnswer) || 0 : 0;

                    return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.question}</td>
                            <td>
                                {row.questionType === 'offen' ? row.answerValue : answer || 'Keine Antwort ausgewählt'}
                            </td>
                            <td>
                                <button className="arcMsgBox-button" onClick={() => togglePopup(question_id)}>Antwort bearbeiten</button>
                                {showPopup === question_id && questionType !== 'offen' && (
                                    <div className="popup-background">
                                        <div className="popup">
                                            <div className="popup-content">
                                                <div className="arcMsgBox-caption">Antwort bearbeiten</div>
                                                {row.question}
                                                <div className={row.questionType === 'offen' ? 'popup-questions-textarea' : 'popup-questions'}>
                                                {row.questionType === 'offen' ? (
                                                        <textarea className='bubbleText_answer' 
                                                            value={row.answerValue}
                                                            onChange={(e) => changeAnswer(question_id, e.target.value)}
                                                        />
                                                    ) : (
                                                    Object.entries(valueToAnswer[question_id]).map(([answerId, answerText]) => (
                                                        <div key={answerId}>
                                                            <input
                                                                type="radio"
                                                                id={`option_${answerId}`}
                                                                name={`answerOptions_${question_id}`}
                                                                className='radio_button'
                                                                value={answerId}
                                                                checked={(popupanswerValue !== 0 && popupanswerValue === parseInt(answerId)) ||
                                                                    (!popupanswerValue && row.answerValue === answerId)}
                                                                onChange={() => changeAnswer(question_id, answerId)}
                                                            />
                                                            <label htmlFor={`option_${answerId}`}>{answerText}</label>
                                                        </div>
                                                        
                                                    )))
                                                }
                                                </div>
                                                <button className="arcMsgBox-button" onClick={() => togglePopup(question_id)}>Übernehmen</button>
                                                <button className="arcMsgBox-button" onClick={() => resetAnswer(question_id)}>Abbrechen</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default ResultTable;
